import React from 'react';

type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'default' | 'brand';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const baseClasses = 'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap';

const variantStyles: Record<BadgeVariant, React.CSSProperties> = {
  primary:   { backgroundColor: '#0063EA', color: '#ffffff' },
  secondary: { backgroundColor: '#F5F7FA', color: '#001A70' },
  success:   { backgroundColor: '#DCFCE7', color: '#166534' },
  warning:   { backgroundColor: '#FEF9C3', color: '#854D0E' },
  error:     { backgroundColor: '#FEE2E2', color: '#991B1B' },
  default:   { backgroundColor: '#F3F4F6', color: '#1F2937' },
  brand:     { backgroundColor: '#001A70', color: '#ffffff' },
};

export const Badge = ({
  variant = 'default',
  children,
  className = '',
  style,
}: BadgeProps) => {
  const baseStyle = variantStyles[variant] ?? variantStyles.default;
  return (
    <span className={`${baseClasses} ${className}`} style={{ ...baseStyle, ...style }}>
      {children}
    </span>
  );
};
